import {
  collection,
  doc,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  where,
  type Unsubscribe,
} from 'firebase/firestore';
import { db } from './firebase';
export const HANDBOOK_TRAINING_VIEWS = 'handbookTrainingViews';

export function handbookTrainingViewDocId(userId: string, nodeId: string): string {
  return `${userId}_${nodeId}`;
}

export function subscribeHandbookTrainingWatchedNodeIds(
  userId: string,
  onData: (watchedNodeIds: Set<string>) => void,
  onError?: (e: Error) => void,
): Unsubscribe {
  const q = query(collection(db, HANDBOOK_TRAINING_VIEWS), where('userId', '==', userId));
  return onSnapshot(
    q,
    snap => {
      const ids = new Set<string>();
      snap.forEach(s => {
        const nodeId = s.data().nodeId;
        if (typeof nodeId === 'string' && nodeId) ids.add(nodeId);
      });
      onData(ids);
    },
    err => onError?.(err as Error),
  );
}

export async function markHandbookTrainingVideoWatched(userId: string, nodeId: string): Promise<void> {
  const id = handbookTrainingViewDocId(userId, nodeId);
  await setDoc(
    doc(db, HANDBOOK_TRAINING_VIEWS, id),
    {
      userId,
      nodeId,
      watchedAt: serverTimestamp(),
    },
    { merge: true },
  );
}
